import { trigger, transition, style, animate } from '@angular/animations';

export function fadeInGlideDown() {
  return trigger('fadeInGlideDown', [
    transition(':enter', [
      style({ opacity: 0, transform: 'translateY(-50px)' }),
      animate(
        '{{duration}}',
        style({ opacity: 1, transform: 'translateY(0)' }),
      ),
    ]),
    transition(':leave', [
      animate(
        '{{duration}}',
        style({ opacity: 0, transform: 'translateY(-50px)' }),
      ),
    ]),
  ]);
}

export function fadeInGlideUp() {
  return trigger('fadeInGlideUp', [
    transition(':enter', [
      style({ opacity: 0, transform: 'translateY(15px)' }),
      animate(
        '{{duration}}',
        style({ opacity: 1, transform: 'translateY(0)' }),
      ),
    ]),
    transition(':leave', [
      animate(
        '{{duration}}',
        style({ opacity: 0, transform: 'translateY(-15px)' }),
      ),
    ]),
  ]);
}

export function fadeInGlideRight() {
  return trigger('fadeInGlideRight', [
    transition(':enter', [
      style({ opacity: 0, transform: 'translateX(-220px)' }),
      animate(
        '{{duration}}',
        style({ opacity: 1, transform: 'translateY(0)' }),
      ),
    ]),
    transition(':leave', [
      animate(
        '{{duration}}',
        style({ opacity: 0, transform: 'translateX(-220px)' }),
      ),
    ]),
  ]);
}
